import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.5 7.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M11.75 3a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5m-5 11A3.75 3.75 0 0 0 3 17.75v2c0 .966.784 1.75 1.75 1.75h14a1.75 1.75 0 0 0 1.75-1.75v-2A3.75 3.75 0 0 0 16.75 14zM4.5 17.75a2.25 2.25 0 0 1 2.25-2.25h10A2.25 2.25 0 0 1 19 17.75v2a.25.25 0 0 1-.25.25h-14a.25.25 0 0 1-.25-.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }